import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Table,
} from "reactstrap";

import { dealsRepo } from "data/repositories/dealsRepo";
import { provincesRepo } from "data/repositories/provincesRepo";

export default function DealsList() {
  const [items, setItems] = useState([]);

  const load = () => {
    setItems(dealsRepo.list());
  };

  useEffect(() => {
    load();
  }, []);

  const provinceNameById = useMemo(() => {
    const map = new Map();
    for (const p of provincesRepo.list()) map.set(p.id, p.name);
    return map;
  }, []);

  const onDelete = (id) => {
    const ok = window.confirm("Fırsat silinsin mi?");
    if (!ok) return;
    dealsRepo.remove(id);
    load();
  };

  return (
    <>
      <div className="header bg-gradient-primary pb-6 pt-5 pt-md-7">
        <Container fluid>
          <div className="header-body">
            <Row className="align-items-center py-4">
              <Col lg="6" xs="7">
                <h6 className="h2 text-white d-inline-block mb-0">Fırsatlar (CRUD)</h6>
              </Col>
              <Col lg="6" xs="5" className="text-right">
                <Button tag={Link} to="/admin/content/deals/new" color="secondary" size="sm">
                  Yeni fırsat
                </Button>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Liste</h3>
              </CardHeader>
              <CardBody>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Başlık</th>
                      <th scope="col">İl</th>
                      <th scope="col">Tema</th>
                      <th scope="col">Tarih</th>
                      <th scope="col">Fiyat</th>
                      <th scope="col" className="text-right">İşlem</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((d) => (
                      <tr key={d.id}>
                        <td>{d.title}</td>
                        <td>{provinceNameById.get(d.provinceId) || d.provinceId}</td>
                        <td>
                          <Badge color="info" pill>
                            {d.theme}
                          </Badge>
                        </td>
                        <td>
                          <span className="text-muted">
                            {d.startDate} → {d.endDate}
                          </span>
                        </td>
                        <td>{d.priceText}</td>
                        <td className="text-right">
                          <Button
                            tag={Link}
                            to={`/admin/content/deals/${d.id}`}
                            color="primary"
                            size="sm"
                            className="mr-2"
                          >
                            Düzenle
                          </Button>
                          <Button color="danger" size="sm" onClick={() => onDelete(d.id)}>
                            Sil
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                {!items.length ? (
                  <div className="text-center text-muted py-4">Henüz fırsat yok. “Yeni fırsat” ile ekleyin.</div>
                ) : null}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
